export default "__VITE_ASSET__Cf_v_AY6__"